<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/img_public/about/h5_banner01.webp" />
				<div class="msg_box">
					<div class="tit_b"
						data-aos="fade-right"
						data-aos-duration="400"
						data-aos-delay="400"
						data-aos-offset="0"
						data-aos-once="true"
					>Core tests</div>
					<div class="tit"
						data-aos="fade-right"
						data-aos-duration="400"
						data-aos-delay="400"
						data-aos-offset="0"
						data-aos-once="true"
					>From Organic to Restful, Full Supply Chain Services <br />@ 2.1 Billion People</div>
				</div>
			</div>
			<!--banner-->
			<!--子导航-->
			<div class="nav_list"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div
					v-for="(value, index) in navList"
					:key="index"
					class="nav_el"
					:class="isActived == index ? 'avtived' : ''"
					@click="navChange(index)"
				>
					<div>{{ value.title }}</div>
				</div>
			</div>
			<!--子导航-->
			<!--企业简介-->
			<template v-if="isActived == 0">
				<qyjj></qyjj>
			</template>
			<!--企业简介-->
			<!--企业文化-->
			<template v-if="isActived == 1">
				<qywh></qywh>
			</template>
			<!--企业文化-->
			<!--荣誉资质-->
			<template v-if="isActived == 2">
				<ryzz></ryzz>
			</template>
			<!--荣誉资质-->
			<!--在线留言-->
			<template v-if="isActived == 3">
				<contact></contact>
			</template>
			<!--在线留言-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import qyjj from './qyjj/index_h5.vue'  //企业简介
import ryzz from './ryzz/index_h5.vue'  //荣誉资质
import qywh from './qywh/index_h5.vue'  //企业文化
import contact from './contact/index_h5.vue'  //在线留言
export default {
	components:{
		navBox,
		footerBox,
		qyjj,
		ryzz,
		qywh,
		contact
	},
	data() {
		return {
			isLoading: true,  //界面loading
			navList: [],
			isActived: 0,
		}
	},
	created(){
		let that = this;
		if(sessionStorage.getItem('navList')) {
			that.navList = JSON.parse(sessionStorage.getItem('navList'))[2].children;
			switch(that.$route.params.aboutId) {
				case 'introduction.html':
					that.isActived = 0;
				break;
				case 'culture.html':
					that.isActived = 1;
				break;
				case 'honor.html':
					that.isActived = 2;
				break;
				case 'contact.html':
					that.isActived = 3;
				break;
			}
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//nav变化
		navChange(index) {
			let that = this;
			that.isActived = index;
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	.nav_list{
		display: flex;
		align-items: end;
		border-bottom: 1px solid #E3E1E6;
		.nav_el{
			flex: 1;
			padding: 0 5px;
			text-align: center;
			div{
				display: inline-block;
				padding: 16px 0 12px 0;
				font-size: 16px;
			}
		}
		.nav_el.avtived{
			div{
				border-bottom: 1px solid #A50073;
				color: #A50073;
			}
		}
	}
	//轮播
	.banner_box{
		.msg_box{
			width: 100%;
			margin: 0 auto;
			position: absolute;
			top: 50%;
			left: 50%;
			padding: 0 20px;
			transform: translate(-50%, -50%);
			color: #ffffff;
			.tit{
				margin-top: 10px;
				font-size: 14px;
			}
			.tit_b{
				font-size: 24px;
				font-weight: bold;
			}
		}
		img{
			width: 100%;
		}
	}
}
</style>